import React from "react"
import AnchorLink from "react-anchor-link-smooth-scroll"
import { NavLink } from "rebass"

const PageLink = props => (
  <NavLink {...props} is={AnchorLink} fontSize={[2, 3, 4]} />
)

export default PageLink



// WEBPACK FOOTER //
// ./src/containers/Layout/Header/PageLink.js